import React, { Component } from 'react'
import querystring from 'query-string'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { receiveItems, searchKeyword, clearItems } from '../../../actions/comment/guestbookComment'
import GuestBookCommentListItem from './GuestBookCommentListItem';
import { parseListParams } from '../../common/CommentListHelper';
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import LoadErrorBox from "../../../components/common/LoadErrorBox";
import * as InitStatus from '../../../constants/common/InitializationStatus';
import LoadingBox from "../../common/LoadingBox";
import {addPrefix} from "../../../utils/UriUtil";

@withRouter
@connect(state => ({
    items: state.guestbookComment.item.items,
    totalCount : state.comment.item.totalCount,
    condition: state.guestbookComment.condition,
}), dispatch => ({
    handleReceiveItems: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    handleSearch: (keyword, type) => {
        dispatch(searchKeyword(keyword, type))
    },
    handleClearItems: () => {
        dispatch(clearItems())
    },
    dispatch
}))
class GuestBookCommentList extends Component {

    constructor(props, context) {
        super(props, context);

		let listParams = parseListParams(props.location.search)
        this.state = {
            initialized : InitStatus.INIT_READY,
            currentPage: listParams.page,
            currentSearchKeyword : listParams.searchKeyword,
            currentSearchType: listParams.searchType,
        }

        this.init = this.init.bind(this);
        this.fetchComments = this.fetchComments.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    componentWillReceiveProps(nextProps) {

        const { currentPage, currentSearchKeyword, currentSearchType } = this.state;
        let listParams = parseListParams(nextProps.location.search)

        if (currentPage !== listParams.page
            ||
            currentSearchKeyword !== listParams.searchKeyword
            ||
            currentSearchType !== listParams.searchType
        ) {
            this.fetchComments(listParams.page, listParams.searchKeyword, listParams.searchType );
            this.setState({
                currentPage: listParams.page,
                currentSearchKeyword : listParams.searchKeyword,
                currentSearchType : listParams.searchType,
            })
        }

    }

    componentWillUnmount() {
        this.props.handleClearItems();
    }

    init() {
        const { currentPage, currentSearchKeyword, currentSearchType} = this.state;

        const { dispatch } = this.props;

        this.setState({
            initialized: InitStatus.INIT_DOING,
        });

        fetch(addPrefix("/manage/guestBookComments.json?") + querystring.stringify({
            page: currentPage,
            searchKeyword: currentSearchKeyword,
            searchType : currentSearchType
        }), {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.items, data.totalCount);
                this.props.handleSearch(currentSearchKeyword, currentSearchType);
                this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
                    currentPage: currentPage
                })
            })
            .catch(e => {
                console.error(e);
                this.props.handleReceiveItems([], 0);
                this.setState({
                    initialized : InitStatus.INIT_FAIL,
                });
            })
    }

    fetchComments(page, searchKeyword, searchType) {

        const { dispatch } = this.props;

        fetch(addPrefix("/manage/guestBookComments.json?") + querystring.stringify({
                page: page,
                searchKeyword: searchKeyword,
                searchType: searchType
            }), {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.items, data.totalCount);
                this.props.handleSearch(searchKeyword, searchType);
                this.setState({
                    currentPage: page
                })
            })
            .catch(e => {
                this.props.handleReceiveItems([], 0)
            })
    }

    render() {
        const { items } = this.props;

        return (
            <div className="wrap_list">
                <ul className="list_post list_post_type3">
                    { this.renderItems(items) }
                </ul>
            </div>
        )
    }

    renderItems(items) {

        const {initialized} = this.state;

        if (initialized === InitStatus.INIT_DOING ) {
            return (<li className="info_none">
                <LoadingBox/>
            </li>);
        }else if(initialized === InitStatus.INIT_FAIL ){
            return (
                <LoadErrorBox retry={this.init}/>
            );
        }else if(initialized === InitStatus.INIT_SUCCESS ) {
            if(items.length === 0 ){
                return this.renderEmptyItems(items);
            }else{
                return items.map(item =>
                    <GuestBookCommentListItem key={item.id} item={item} />
                )
            }
        }
    }

    renderEmptyItems() {

        const { condition, totalCount } = this.props;
        const { searchKeyword } = condition;
        const haveZeroPost = (searchKeyword === '' );
        const tooManyPostMatched = (totalCount === -1);

        if(haveZeroPost) {
            return <li className="info_none">
                <div className="txt_none">
                    <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
                    아직 등록된 방명록 글이 없습니다.
                </div>
            </li>
        }else if(tooManyPostMatched) {
            return <li className="info_none">
                <div className="txt_none">
                    <span className="wrap_ico"><span className="ico_blog ico_search"/></span>
                    검색 결과가 너무 많습니다. <br/>
                    구체적인 단어로 다시 검색해보세요.
                </div>
            </li>
        }else{
            return <li className="info_none">
                <div className="txt_none">
                    <span className="wrap_ico"><span className="ico_blog ico_search"/></span>
                    검색 결과가 없습니다.
                </div>
            </li>
        }
    }

}

export default GuestBookCommentList;

